import classNames from 'classnames';

export const FolderBtn = ({
    isFolderOepn,
    isFolderOepnSet,
    ga360DataContents,
}: {
    isFolderOepn: boolean;
    isFolderOepnSet: (bool: boolean) => void;
    ga360DataContents?: string;
}) => {
    return (
        <button
            className={classNames('btn-folder', { 'is-active': isFolderOepn })}
            data-areas={ga360DataContents ? '시세_아이템상세_영역접기펴기_클릭' : ''}
            data-contents={ga360DataContents}
            onClick={() => isFolderOepnSet(!isFolderOepn)}
        />
    );
};
